var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionRequestManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 507,
    viewBox: "0 0 512 507",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_168_1736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.25 236.978C306.937 247.967 317.115 260.535 325.73 274.663C347.509 261.017 373.235 253.113 400.778 253.113C412.444 253.113 423.78 254.54 434.634 257.21C417.183 234.368 396.162 217.457 369.579 204.935C349.646 223.12 323.773 234.896 295.25 236.978ZM259.024 394.866C259.024 355.299 275.326 319.474 301.557 293.734C286.78 268.122 266.613 248.828 240.415 235.25C218.829 250.111 192.699 258.825 164.569 258.825C136.519 258.825 110.459 250.162 88.9091 235.38C34.3273 264.898 0 326.331 0 397.268V506.089H312.993C280.142 480.105 259.024 439.907 259.024 394.866ZM298.662 124.731C298.662 153.454 289.581 180.094 274.144 201.937L274.923 206.115C278.634 206.559 282.385 206.782 286.142 206.782C337.634 206.782 379.526 164.89 379.526 113.398C379.526 61.9052 337.634 20.0132 286.142 20.0132C275.403 20.0046 264.742 21.8496 254.631 25.4671C281.663 50.0173 298.662 85.4264 298.662 124.731Z",
    fill: "#FF5722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.452 225.428C244.105 212.232 278.522 156.419 265.325 100.767C252.129 45.1148 196.315 10.6981 140.663 23.8948C85.0105 37.0915 50.5932 92.9044 63.7898 148.556C76.9864 204.208 132.8 238.625 188.452 225.428Z",
    fill: "#FF5722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 394.866C512 333.538 462.106 283.643 400.778 283.643C339.45 283.643 289.555 333.538 289.555 394.866C289.555 456.194 339.45 506.088 400.778 506.088C462.106 506.089 512 456.195 512 394.866ZM335.995 410.131V379.6H385.511V330.084H416.042V379.6H465.558V410.131H416.042V459.648H385.511V410.131H335.995Z",
    fill: "#FF5722"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_168_1736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 506.089,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionRequestManagement);
export default __webpack_public_path__ + "static/media/subscription-request-management.8ab3cfacac5c0066c40d2e67d09ffa5a.svg";
export { ForwardRef as ReactComponent };